module.exports = __webpack_public_path__ + "static/media/2025학년도 한성과학고등학교 발명교육센터 발명심화・특별과정 운영 계획.970d21d2.pdf";